/*
Application Name: Practice Aid.
Application URI: https://practice-aid.com/
Description: PracticeAid is a group of professionals with collective expertise in medical and dental science, hospital administration and software development. These experts have come together to work on path-breaking solutions in Healthcare IT and deliver tangible value.
Version: 1.0.0
Author: Practice Aid.
Author URI: https://practice-aid.com/
 “M/s Totall Practice Aid Private Limited, CIN U72900MP2022PTC059139”
*/

import {
    getRequest,
    postRequest,
    getRequestWithToken,
    postRequestWithToken,
    postRequestWithTokenFile,
    requestWithTokenQuery,
    putRequestWithToken,
    deleteRequestWithToken
} from "./helper";


export const serviceList = (data) => requestWithTokenQuery(data, 'bill/service/list');

export const categoryList = (data) => requestWithTokenQuery(data, 'bill/category/list');

export const addService = (data) => postRequestWithToken(data, 'bill/service/create')

export const updateService = (data) => putRequestWithToken(data, 'bill/service/update')

export const addBillCategory = (data) => postRequestWithToken(data, 'bill/category/create')

export const updateBillCategory = (data) => putRequestWithToken(data, `bill/category/update`)

export const updateStatus = (data) => putRequestWithToken(data, `bill/category/delete`)

export const billingList = (data) => requestWithTokenQuery(data, `bill/list`)

export const servicesBasedOnCategory = (catId) => requestWithTokenQuery(catId, `bill/service/list/${catId}`);

export const createBill = (data) => postRequestWithToken(data, 'bill/create');

export const recoveryBill = (data) => postRequestWithToken(data, 'bill/recovery');

export const updateBill = (data) => putRequestWithToken(data, `bill/update`)

export const getBillDetails = (billNo) => getRequestWithToken(billNo, `bill/summary/${billNo}`)

export const getBillReport = (data) => requestWithTokenQuery(data, `bill/service`);

export const billRefund = (data) => postRequestWithToken(data, `bill/refund`)

export const setCustomBillNumber = (data) => postRequestWithToken(data, `bill/setBillStartIndex`)




